import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "top-bar-left"
}
const _hoisted_2 = {
  key: 1,
  class: "top-bar"
}
const _hoisted_3 = {
  key: 2,
  class: "top-date"
}
const _hoisted_4 = {
  key: 0,
  class: "date-line"
}
const _hoisted_5 = {
  key: 1,
  class: "time-line"
}
const _hoisted_6 = {
  key: 3,
  class: "bottom-bar"
}
const _hoisted_7 = {
  key: 0,
  class: "exif title"
}
const _hoisted_8 = {
  key: 1,
  class: "exif description"
}
const _hoisted_9 = {
  key: 2,
  class: "exif date"
}
const _hoisted_10 = ["aria-label", "title", "onClick"]
const _hoisted_11 = { class: "label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImageEditor = _resolveComponent("ImageEditor")!
  const _component_XLoadingIcon = _resolveComponent("XLoadingIcon")!
  const _component_BackIcon = _resolveComponent("BackIcon")!
  const _component_NcButton = _resolveComponent("NcButton")!
  const _component_NcActionButton = _resolveComponent("NcActionButton")!
  const _component_NcActions = _resolveComponent("NcActions")!
  const _component_MobileBottomBar = _resolveComponent("MobileBottomBar")!
  const _component_ViewerSheetGestures = _resolveComponent("ViewerSheetGestures")!
  const _component_ViewerBottomSheet = _resolveComponent("ViewerBottomSheet")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref: "outer",
        class: _normalizeClass(["memories-viewer outer remove-gap", {
      'fully-opened': _ctx.fullyOpened,
      'is-video': _ctx.isVideo,
      'is-slideshow': !!_ctx.slideshowTimer,
      'force-metadata': !!_ctx.slideshowTimer && _ctx.config.metadata_in_slideshow,
    }]),
        style: _normalizeStyle({ width: _ctx.outerWidth }),
        onFullscreenchange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.fullscreenChange && _ctx.fullscreenChange(...args)))
      }, [
        (_ctx.editorOpen && _ctx.currentPhoto)
          ? (_openBlock(), _createBlock(_component_ImageEditor, {
              key: 0,
              photo: _ctx.currentPhoto,
              onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editorOpen = false))
            }, null, 8, ["photo"]))
          : _createCommentVNode("", true),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_XLoadingIcon, {
              key: 1,
              class: "loading-icon centered"
            }))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", {
          ref: "inner",
          class: "inner",
          onPointermovePassive: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.setUiVisible && _ctx.setUiVisible(...args))),
          onPointerdownPassive: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.setUiVisible && _ctx.setUiVisible(...args))),
          onTouchstartPassive: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.tapPatch.onTouchStart && _ctx.tapPatch.onTouchStart(...args))),
          onTouchend: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.tapPatch.onTouchEnd && _ctx.tapPatch.onTouchEnd(...args))),
          onTouchcancelPassive: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.tapPatch.onTouchCancel && _ctx.tapPatch.onTouchCancel(...args)))
        }, [
          (_ctx.photoswipe)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_NcButton, {
                  variant: "tertiary-no-background",
                  "aria-label": _ctx.t('memories', 'Back'),
                  title: _ctx.t('memories', 'Back'),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => {
            _ctx.beep();
            _ctx.close();
          })
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_BackIcon, { size: 24 })
                  ]),
                  _: 1
                }, 8, ["aria-label", "title"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.photoswipe)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_NcActions, {
                  inline: _ctx.numInlineTopActions,
                  container: ".memories-viewer .pswp"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topActions, (action) => {
                      return (_openBlock(), _createBlock(_component_NcActionButton, {
                        key: action.id,
                        "aria-label": action.name,
                        "close-after-click": "",
                        onClick: ($event: any) => {
              _ctx.beep();
              action.callback();
            }
                      }, {
                        icon: _withCtx(() => [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(action.icon), _mergeProps({ size: 24 }, { ref_for: true }, action.iconArgs ?? {}), null, 16))
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(action.name) + " ", 1)
                        ]),
                        _: 2
                      }, 1032, ["aria-label", "onClick"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["inline"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.photoswipe)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_ctx.currentDateStr)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.currentDateStr), 1))
                  : _createCommentVNode("", true),
                (_ctx.currentTimeStr)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createTextVNode(_toDisplayString(_ctx.currentTimeStr) + " ", 1),
                      (_ctx.currentAddressShort)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" • " + _toDisplayString(_ctx.currentAddressShort), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.photoswipe)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_ctx.currentPhoto?.imageInfo?.exif?.Title)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.currentPhoto.imageInfo.exif.Title), 1))
                  : _createCommentVNode("", true),
                (_ctx.currentPhoto?.imageInfo?.exif?.Description)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.currentPhoto.imageInfo.exif.Description), 1))
                  : _createCommentVNode("", true),
                (_ctx.currentDateTaken)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createTextVNode(_toDisplayString(_ctx.currentDateTaken), 1),
                      (_ctx.currentAddressShort)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" • " + _toDisplayString(_ctx.currentAddressShort), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.photoswipe && _ctx.bottomActions.length)
            ? (_openBlock(), _createBlock(_component_MobileBottomBar, {
                key: 4,
                class: "viewer-mobile-actions",
                dark: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bottomActions, (action) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: action.id,
                      class: "mobile-bottom-bar-item",
                      "aria-label": action.name,
                      title: action.name,
                      onClick: ($event: any) => {
            _ctx.beep();
            action.callback();
          }
                    }, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(action.icon), _mergeProps({ size: 24 }, { ref_for: true }, action.iconArgs ?? {}), null, 16)),
                      _createElementVNode("span", _hoisted_11, _toDisplayString(action.name), 1)
                    ], 8, _hoisted_10))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 544), [
          [_vShow, !_ctx.editorOpen]
        ]),
        (_ctx.isMobileLayout && _ctx.photoswipe)
          ? (_openBlock(), _createBlock(_component_ViewerSheetGestures, {
              key: 2,
              photoswipe: _ctx.photoswipe,
              onOpen: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setBottomSheet(true)))
            }, null, 8, ["photoswipe"]))
          : _createCommentVNode("", true),
        (_ctx.sheetOpen && _ctx.isMobileLayout)
          ? (_openBlock(), _createBlock(_component_ViewerBottomSheet, {
              key: 3,
              photo: _ctx.currentPhoto,
              onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setBottomSheet(false)))
            }, null, 8, ["photo"]))
          : _createCommentVNode("", true)
      ], 38))
    : _createCommentVNode("", true)
}